import React from 'react';

const NotificationContactSupport: React.FC = () => (
    <div className={'contact-support-message'}>
        <span>Please try again or if problem persists, contact support.</span>
    </div>
);

export default NotificationContactSupport;
